import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import SimpleTransactionForm from './SimpleTransactionForm';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const RantingTransactionTabs = ({ onSubmit, onCancel, activeTab, setActiveTab, isLapangan }) => {

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const tabsConfig = [
    { label: "Penerimaan Infak", type: "penerimaan-infak", title: "Tambah Penerimaan Infak" },
    { label: "Penerimaan Dana Amil", type: "penerimaan-dana-amil", title: "Tambah Penerimaan Dana Amil" },
    { label: "Penerimaan Zakat", type: "penerimaan-zakat", title: "Tambah Penerimaan Zakat" },
    { label: "Penyaluran", type: "penyaluran", title: "Tambah Penyaluran", restricted: true },
    { label: "Beban Pengelolaan", type: "beban-pengelolaan", title: "Tambah Beban Pengelolaan", restricted: true },
  ];

  const visibleTabs = tabsConfig.filter(tab => !tab.restricted || !isLapangan);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={handleChange} aria-label="transaction tabs" variant="scrollable" scrollButtons="auto">
          {visibleTabs.map((tab, index) => (
             <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      {visibleTabs.map((tab, index) => (
        <TabPanel key={index} value={activeTab} index={index}>
          <SimpleTransactionForm 
            title={tab.title} 
            onSubmit={onSubmit} 
            onCancel={onCancel} 
            type={tab.type} 
          />
        </TabPanel>
      ))}
    </Box>
  );
};

export default RantingTransactionTabs;
